import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';
import { GamIconName } from '@/views/composables/constants/components/gamIcon.constants';
import type { GamButtonType } from '@/views/composables/models/components/GamButton';

type BackButtonOptions = {
  size?: 'small' | 'large';
};

export default class GamHelper {
  static createId = (id: string): string => {
    return `${id}-${Math.random().toString(16).slice(2)}`;
  };

  static getMobileBack = (options?: BackButtonOptions): GamButtonType => {
    return {
      size: GamButtonSize.ACTIONS,
      variant: GamButtonVariant.TERTIARY,
      leftIcon: options?.size === 'large' ? GamIconName.ARROW_LEFT : GamIconName.SMALL_ARROW_LEFT,
    };
  };

  static removeItem<T>(arr: Array<T>, value: T): Array<T> {
    const index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  static getCurrentUrl(): string {
    const url: string[] = window.location.href.split('/');
    return url[0] + '//' + url[2];
  }

  static getItem<T>(array?: T[], index?: number): T | null {
    if (index?.toString() && array?.[index]) {
      return array[index];
    }
    return null;
  }
}
